<div class="du-bg-bookmark">
  <!-- Header -->
  <div class="p-3 d-flex align-items-center justify-content-between" style="gap: 15px;">
    <div class="du-bookmark-headerText" [matTooltip]="this.bookmarkInnerGroup?.bookmark_name" matTooltipClass="du-bookmark-tooltip" matTooltipPosition="above">
      <span class="du-bookmark-headerName">
        {{ this.bookmarkInnerGroup?.bookmark_name || 'Share bookmark' }}
      </span>
    </div>
    <span class="du-cancel-icon" (click)="hideTooltip()">
      <svg width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.97026 1.44514L6.0002 4.41521L3.03013 1.44514C2.70223 1.11724 2.17 1.11724 1.8421 1.44514L1.44612 1.84113C1.11822 2.16902 1.11822 2.70126 1.44612 3.02915L4.41618 5.99922L1.44612 8.96929C1.11822 9.29718 1.11822 9.82942 1.44612 10.1573L1.8421 10.5533C2.17 10.8812 2.70223 10.8812 3.03013 10.5533L6.0002 7.58323L8.97026 10.5533C9.29816 10.8812 9.83039 10.8812 10.1583 10.5533L10.5543 10.1573C10.8822 9.82942 10.8822 9.29718 10.5543 8.96929L7.58421 5.99922L10.5543 3.02915C10.8822 2.70126 10.8822 2.16902 10.5543 1.84113L10.1583 1.44514C9.83039 1.11724 9.29816 1.11724 8.97026 1.44514Z" fill="#8A98AB"/>
      </svg>
    </span>
    <!-- <mat-icon class="du-cancel-icon" (click)="hideTooltip()" svgIcon="cancel_x"></mat-icon> -->
  </div>

  <hr class="du-hr-line" />

  <!-- Search -->
  <div class="p-3 pb-2" style="position: relative;" *ngIf="!loader && !sharedLoader">
    <span style="position: absolute; top: 23px; left: 20px;">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z" stroke="#8A98AB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11.3335 11.332L14.0002 13.9987" stroke="#8A98AB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span>
    <input
      type="search"
      class="du-bookmark-search"
      placeholder="Search"
      name="patietStatusSearch"
      [(ngModel)]="bookmarkSearchText"
    />
  </div>

  <!-- Sharing Load -->
  <div *ngIf="sharedLoader"  style="flex: 1; overflow-y: auto;overflow-x: hidden;align-items: center;justify-content: center;align-content: center;align-self: center;" >
    <div *ngIf="this.sharedBookmarkLoader" style="text-align: center;">
      <div class="circle-loader">
        <div class="checkmark draw"></div>
      </div>

      <div *ngIf="this.errorValue" style="text-align: center;">
        <p class="followStatusParag">Successfully shared!</p>
      </div>
    </div>

    <div *ngIf="!this.sharedBookmarkLoader" style="text-align: center;">
      <div style="text-align: center;margin-bottom: 25px;">
        <svg style="width: 50px;height: 50px;color: red;" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
          <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
        </svg>
      </div>
  
      <div *ngIf="this.errorValue" style="text-align: center;">
        <p class="followStatusParag">Try again later...!</p>
      </div>
    </div>
    <div style="text-align: center;" *ngIf="errorValue">
      <button mat-raised-button class="mat-raised-buttons my-gradient-apply-button" (click)="gotItforValue()">Got it</button>
    </div>

  </div>
  
  <!-- Initial Load -->
  <div *ngIf="loader && !sharedLoader" style="flex: 1; overflow-y: auto;overflow-x: hidden;align-items: center;justify-content: center;align-content: center;align-self: center;" >
    <div class="circle-loader">
      <div class="checkmark draw"></div>
    </div>
  </div>
  
  <section class="section-du-bookmark-userlist du-bookmark-select-all" *ngIf="bookmarkUsers.length>0 && !loader && !sharedLoader">
    <mat-checkbox
        class="du-bookmark-userlist"
        [color]="'primary'"
        [(ngModel)]="selectedAll"
        (ngModelChange)="selectedAllChanges(selectedAll)"
        [labelPosition]="'before'"
        [disabled]="false"
        >
      {{ 'Select All' }}
    </mat-checkbox>
  </section>

  <div class="du-scrollable-content-bookmark-share" *ngIf="!loader && !sharedLoader">
    <!-- User List -->
    <ng-container *ngIf="(bookmarkUsers | searchText: bookmarkSearchText)?.length > 0; else noResults">
      <section class="section-du-bookmark-userlist" *ngFor="let user of bookmarkUsers | searchText: bookmarkSearchText">
        <mat-checkbox
            [class]="user.disabled?'du-bookmark-userlist-diabled':'du-bookmark-userlist'"
            [color]="'primary'"
            [(ngModel)]="user.checked"
            [labelPosition]="'before'"
            [disabled]="user.disabled"
            >
          {{ user.user_nm }}
        </mat-checkbox>
      </section>
    </ng-container>
    <ng-template #noResults>
      <ng-container *ngIf="!loader; else showResults">
        <div class="no-results">
          <div class="load-error-handle-du-share-bookmark">No Users found.</div>
        </div>
      </ng-container>
    </ng-template>

    <ng-template #showResults>
      <div class="no-results">
        <div class="load-error-handle-du-share-bookmark">Loading...</div>
      </div>
    </ng-template>
  </div>

  <!-- Footer Button Row -->
  <div class="d-flex align-items-center justify-content-end px-3 py-2" style="border-top: 1px solid #EBEBEB;gap: 10px;" *ngIf="!loader && !sharedLoader">
    <!-- <button mat-button style="color: #1363DF; font-size: 12px;">Remove All</button> -->
     <span style="font-size: 12px;color: #D11044;">{{this.error || ''}}</span>
    <button mat-raised-button class="mat-raised-buttons my-gradient-apply-button" (click)="shareBookmarks(bookmarkUsers)">Share</button>
  </div>
</div>
